
import Vue from 'vue';
import { Icon, Link } from '@descomplica/vue-components';
import { UnifiedCommentModel } from '@/models/UnifiedCommentModel';
import { ReactionsEnum } from '../../store/modules/reactions/actions';
import { UserModel } from '@descomplica/dex-models';
import { ReactionInfo } from '@/models/ReactionsModel';

export default Vue.extend({
  components: {
    Icon,
    Link,
  },
  props: {
    showLikeAndDislikeButtons: {
      type: Boolean,
      default: true,
    },
    showFeedbackButton: {
      type: Boolean,
      default: true,
    },
    showRepliesCount: {
      type: Boolean,
      default: true,
    },
    comment: {
      type: Object as Vue.PropType<UnifiedCommentModel>,
      required: true,
    },
  },
  computed: {
    reactions(): ReactionInfo[] | any {
      return this.comment.reactions || [];
    },
    likeInfo(): ReactionInfo {
      return (
        this.reactions.find((reaction: ReactionInfo) => reaction.reaction === ReactionsEnum.LIKE) ||
        {}
      );
    },
    dislikeInfo(): ReactionInfo {
      return (
        this.reactions.find(
          (reaction: ReactionInfo) => reaction.reaction === ReactionsEnum.DISLIKE,
        ) || {}
      );
    },
    user(): UserModel {
      return this.$store.getters.currentUser;
    },
  },
  methods: {
    toggleReplies() {
      this.$emit('onToggleReplies');
    },
    likeClick(liked: boolean) {
      const userDislikedBefore = this.dislikeInfo.userReacted;

      if (liked && userDislikedBefore) {
        this.$store.dispatch('REMOVE_REACTION', {
          contentId: this.comment.contentReactionId,
          reaction: ReactionsEnum.DISLIKE,
        });
      }

      const action = liked ? 'ADD_REACTION' : 'REMOVE_REACTION';

      this.$store.dispatch(action, {
        contentId: this.comment.contentReactionId,
        reaction: ReactionsEnum.LIKE,
      });

      this.$emit('onLikeClick', liked);
    },
    dislikeClick(disliked: boolean) {
      const userLikedBefore = this.likeInfo.userReacted;

      if (disliked && userLikedBefore) {
        this.$store.dispatch('REMOVE_REACTION', {
          contentId: this.comment.contentReactionId,
          reaction: ReactionsEnum.LIKE,
        });
      }

      const action = disliked ? 'ADD_REACTION' : 'REMOVE_REACTION';

      this.$store.dispatch(action, {
        contentId: this.comment.contentReactionId,
        reaction: ReactionsEnum.DISLIKE,
      });

      this.$emit('onDislikeClick', disliked);
    },
    feedbackClick() {
      this.$emit('onFeedbackClick');
    },
  },
});
